/* eslint-disable react-refresh/only-export-components -- context + hook no mesmo módulo */
import type { CapitalGlobalProposalStep2FormContextValue } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step2-form-context-value.types';
import { createContext, useContext, type ReactNode } from 'react';

export type { CapitalGlobalProposalStep2FormContextValue } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step2-form-context-value.types';

const CapitalGlobalProposalStep2FormContext =
  createContext<CapitalGlobalProposalStep2FormContextValue | null>(null);

export function CapitalGlobalProposalStep2FormProvider({
  value,
  children,
}: {
  value: CapitalGlobalProposalStep2FormContextValue;
  children: ReactNode;
}) {
  return (
    <CapitalGlobalProposalStep2FormContext.Provider value={value}>
      {children}
    </CapitalGlobalProposalStep2FormContext.Provider>
  );
}

export function useCapitalGlobalProposalStep2Form() {
  const ctx = useContext(CapitalGlobalProposalStep2FormContext);
  if (!ctx) {
    throw new Error(
      'useCapitalGlobalProposalStep2Form must be used within CapitalGlobalProposalStep2FormProvider'
    );
  }
  return ctx;
}
